import { jsx as _jsx } from "react/jsx-runtime";
import { FloatingPortal } from '@floating-ui/react';
import { useColorScheme } from '../ColorScheme';
export const Portal = (props) => {
    const { root: rootProp, children, disabled } = props;
    const { root: rootColorScheme } = useColorScheme();
    const root = rootProp ?? rootColorScheme;
    return disabled ? (children) : (_jsx(FloatingPortal, { root: root, children: children }));
};
